import * as BootstrapIcons from "react-icons/bs";

export function getIcon(params:{collection:string, id:string}) {
  if(params.collection == 'bootstrap')
    return BootstrapIcons[`${params.id}`];
  return null;
}